import {Observable} from 'rxjs';
import {filter}     from 'rxjs/operators';

import IMedia from '../../../../Player/Interfaces/IMedia';

const createConsumerMediaStream = (
    media$: Observable<IMedia>
): Observable<IMedia> =>
    media$
        .pipe(
            filter(Boolean)
        );

export default createConsumerMediaStream;